export const CREATE_INSURANCENEED_START = "CREATE_INSURANCENEED_START";
export const CREATE_INSURANCENEED_FAILURE = "CREATE_INSURANCENEED_FAILURE";
export const CREATE_INSURANCENEED_SUCCESS = "CREATE_INSURANCENEED_SUCCESS";
export const CREATE_INSURANCENEED_RESET = "CREATE_INSURANCENEED_RESET";

export const GET_INSURANCENEED_START = "GET_INSURANCENEED_START";
export const GET_INSURANCENEED_FAILURE = "GET_INSURANCENEED_FAILURE";
export const GET_INSURANCENEED_SUCCESS = "GET_INSURANCENEED_SUCCESS";
export const GET_INSURANCENEED_RESET = "GET_INSURANCENEED_RESET";


export const GET_INCOME_START = "GET_INCOME_START";
export const GET_INCOME_FAILURE = "GET_INCOME_FAILURE";
export const GET_INCOME_SUCCESS = "GET_INCOME_SUCCESS";
export const GET_INCOME_RESET = "GET_INCOME_RESET";

// Delete Insurance Need
export const DELETE_INSURANCE_NEED_START = "DELETE_INSURANCE_NEED_START";
export const DELETE_INSURANCE_NEED_SUCCESS = "DELETE_INSURANCE_NEED_SUCCESS";
export const DELETE_INSURANCE_NEED_FAILURE = "DELETE_INSURANCE_NEED_FAILURE";
export const DELETE_INSURANCE_NEED_RESET = "DELETE_INSURANCE_NEED_RESET";

export const UPDATE_INSURANCE_NEED = "UPDATE_INSURANCE_NEED"
export const UPDATE_INSURANCE_NEED_SUCCESS = "UPDATE_INSURANCE_NEED_SUCCESS"
export const UPDATE_INSURANCE_NEED_FAILED = "UPDATE_INSURANCE_NEED_FAILED"